import React from "react";
import { Link } from "react-router-dom";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import facilityImg from "../img/Üretim-Kalitemiz.jpg";
import whyWe from "../img/neden-biz.jpg";
import useSWR from "swr";
import LanguageApi from "../components/Language";
import Featured from "../components/Featured";
const Home = () => {
  const { data, error } = useSWR(process.env.REACT_APP_DEF_URL + "slidersD");
  const {
    go,
    why_us,
    why_us_text,
    our_production_quality,
    our_production_quality_text,
    our_featured_products,
    have_something_on_your_mind,
    contanct_go,
    language_code
  } = LanguageApi();
  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  return (
    <div className="home">
      <div className="home-carousel">
        <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
          {
            language_code ==="tr" ? data.tr.map((data) => (
              <SwiperSlide>
                <div className="slider-r">
                  <div className="slider-text">
                    <h1>{data.slider_title}</h1>
                    <p>{data.slider_text}</p>
                    {data.slider_link_status === "0" ? (
                      <Link to={data.slider_link} className="slider-button">
                        {go}
                      </Link>
                    ) : (
                      <a href={data.slider_link} className="slider-button">
                        {go}
                      </a>
                    )}
                  </div>
                  <img
                    src={process.env.REACT_APP_DEF_URL + data.slider_image}
                    alt={data.slider_title}
                    className={"slider-image"}
                  />
                  <div className="slider-text-gradient"></div>
                </div>
              </SwiperSlide>
            )) : data.en.map((data) => (
              <SwiperSlide>
                <div className="slider-r">
                  <div className="slider-text">
                    <h1>{data.slider_title}</h1>
                    <p>{data.slider_text}</p>
                    {data.slider_link_status === "0" ? (
                      <Link to={data.slider_link} className="slider-button">
                        {go}
                      </Link>
                    ) : (
                      <a href={data.slider_link} className="slider-button">
                        {go}
                      </a>
                    )}
                  </div>
                  <img
                    src={process.env.REACT_APP_DEF_URL + data.slider_image}
                    alt={data.slider_title}
                    className={"slider-image"}
                  />
                  <div className="slider-text-gradient"></div>
                </div>
              </SwiperSlide>
            ))
          }
          
        </Swiper>
      </div>
      <div className="home-content-1 sbg">
        <div className="home-content-1-1-rightstyle home-content-flex">
          <div className="content-text">
            <h1>{why_us} </h1>
            <p>{why_us_text}</p>
          </div>
          <div className="content-image ">
            <div className="image-bg-1">
              <div className="content-blok b1"></div>
              <img src={whyWe} alt="cow-aven" className="i1" />
            </div>
          </div>
        </div>
      </div>
      <div className="home-content-3">
        <div className="production-facility">
          <div className="production-facility-text">
            <h1>{our_production_quality}</h1>
            <p>{our_production_quality_text}</p>
          </div>
          <div className="production-facility-image">
            <img src={facilityImg} alt="production facility" />
          </div>
        </div>
      </div>
      <div className="home-content-4 sbg">
        <h1>{our_featured_products}</h1>
        <div className="products-area">
            <Featured/>
        </div>
      </div>
      <div className="home-content-6">
        <div className="home-content-6-content">
          <h1>{have_something_on_your_mind}</h1>
          <div className="home-content-6-button-area">
            <Link to={"/contact"} className="home-content-6-button">
              {contanct_go}
            </Link>
          </div>
        </div>

        <div className="home-content-shadow"></div>
      </div>
    </div>
  );
};

export default Home;
